type ReadFieldFunction = (fieldName: string, object?: any) => any;
type MergeObjectsFunction = (existing: any, incoming: any) => any;

export function mergeArrayByIndex<T>(debugName: string | undefined = undefined) {
  return function (
    existing: T[] | undefined,
    incoming: T[] | undefined,
    { readField: _readField, mergeObjects }: { readField: ReadFieldFunction; mergeObjects: MergeObjectsFunction },
  ): T[] {
    const merged: T[] = existing ? existing.slice(0) : [];

    incoming?.forEach((item, index) => {
      const existingFieldValue = existing?.[index];
      if (existingFieldValue) {
        // Merge the new author data with the existing author data.
        merged[index] = mergeObjects(merged[index], item);
      } else {
        merged.push(item);
      }
    });

    if (debugName) {
      // console.log('mergeArrayByIndex', debugName, {
      //   existing,
      //   incoming,
      //   merged,
      // });
    }
    return merged;
  };
}
